import { render, staticRenderFns } from "./Ratgeber.vue?vue&type=template&id=71ff97e8&scoped=true&"
import script from "./Ratgeber.vue?vue&type=script&lang=js&"
export * from "./Ratgeber.vue?vue&type=script&lang=js&"
import style0 from "./Ratgeber.vue?vue&type=style&index=0&id=71ff97e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff97e8",
  null
  
)

export default component.exports